// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-areas-to-focus .button-container.float,
.page-struggle .button-container.float,
.page-bad-habits .button-container.float,
.page-weight-on-events .button-container.float {

  position: static;
  margin: auto auto 60px;
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/multi-select-pages.css"],"names":[],"mappings":"AAAA;;;;;EAKE,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":[".page-areas-to-focus .button-container.float,\n.page-struggle .button-container.float,\n.page-bad-habits .button-container.float,\n.page-weight-on-events .button-container.float {\n\n  position: static;\n  margin: auto auto 60px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
